import { type RefObject, useEffect, useState } from "react";
import { getAemNavOffset } from "../../../../common-deprecated/utils";

/**
 * Returns a boolean indicating whether the filter bar should be fixed or not.
 * This is determined by checking if the top of the results container is in the viewport.
 */
const useFixedFilterBar = (resultsContainer: RefObject<HTMLElement>, offset: number = 0): boolean => {
    const [isFixed, setFixed] = useState(false);

    useEffect(() => {
        const updateScroll = (): void => {
            const containerIntersectsHeader =
                resultsContainer.current &&
                getAemNavOffset() + offset > resultsContainer.current.getBoundingClientRect().top;

            if (containerIntersectsHeader && !isFixed) {
                setFixed(true);
            } else if (!containerIntersectsHeader && isFixed) {
                setFixed(false);
            }
        };

        // Execute once during render to make sure it is still correct (if nav height changes or during mount)..
        updateScroll();

        window.addEventListener("resize", updateScroll);
        window.addEventListener("scroll", updateScroll);

        return () => {
            window.removeEventListener("resize", updateScroll);
            window.removeEventListener("scroll", updateScroll);
        };
    }, [resultsContainer, isFixed, offset]);

    return isFixed;
};

export default useFixedFilterBar;
